// extracted by mini-css-extract-plugin
module.exports = {"footer":"qP-Bo","link":"_1GaFR","logo-arrow-wrapper":"fe7VL","up-arrow":"_130lK"};